/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import ReportParametersModel from '../model/ReportParametersModel';
import Backbone from 'backbone';

var ReportParametersCollection = Backbone.Collection.extend({
    model: ReportParametersModel,
    getReportParameters: function (uri, options) {
        return this.add({ reportUri: uri }).getReportParameters(options);
    },
    getReportControls: function (uri, options) {
        return this.add({ reportUri: uri }).getReportControls(options);
    },
    getInputControlAsParameter: function (reportUri, controlUri, options) {
        return this.add({ reportUri: reportUri }).getInputControlAsParameter(controlUri, options);
    }
});
ReportParametersCollection.instance = new ReportParametersCollection();
export default ReportParametersCollection;